import firestore, { firebase } from '@/firebase'
import axios from 'axios'
import { setUserProperty } from '../../firebase/analytics'

export default {
  state: {
    user: null,
    profile: null,
    notificationSubscriptionId: null
  },
  getters: {
    notificationSubscriptionId: state => state.notificationSubscriptionId,
    user: state => state.user,
    profile: state => state.profile,
    username: state => {
      return state.user && state.user.firstName
        ? `${state.user.firstName} ${state.user.lastName || ''}`
        : (state.profile && state.profile.username) || ''
    },
    specialty: state => state.user && state.user.specialty,
    hospital: state => state.user && state.user.hospital,
    picture: state =>
      state.user && state.user.picture
        ? state.user.picture
        : state.profile.picture,
    residencyYear: state => {
      if (!state.user.residencyStart) return 0
      const [year, month] = state.user.residencyStart.split('-')
      const startDate = new Date(year, month - 1)
      let residencyYear = new Date().getFullYear() - startDate.getFullYear()

      residencyYear = residencyYear === 0 ? 1 : residencyYear

      if (
        new Date().getFullYear() > startDate.getFullYear() &&
        new Date().getMonth() - startDate.getMonth() >= 0
      ) {
        residencyYear++
      }

      return residencyYear
    }
  },
  mutations: {
    setNotificationSubscriptionId(state, notificationSubscriptionId) {
      state.notificationSubscriptionId = notificationSubscriptionId
    },
    setUser(state, user) {
      state.user = user
    },
    setProfile(state, profile) {
      state.profile = profile
    }
  },
  actions: {
    setNotificationSubscriptionId({ commit }, notificationSubscriptionId) {
      commit('setNotificationSubscriptionId', notificationSubscriptionId)
    },
    getUser({ rootGetters, commit }, userId) {
      return axios
        .get(`/users/${userId}`, {
          headers: {
            Authorization: `Bearer ${rootGetters.accessToken}`
          }
        })
        .then(response => {
          const user = response.data
          commit('setUser', user)
          return user
        })
    },
    setUser({ commit }, user) {
      commit('setUser', user)
      setUserProperty('SPECIALTY', user.specialty)
    },
    putUser({ rootGetters, state }) {
      const updatedAt = firebase.firestore.FieldValue.serverTimestamp()

      return axios
        .put(
          `/users/${state.user.id}`,
          { ...state.user, updatedAt },
          {
            headers: {
              Authorization: `Bearer ${rootGetters.accessToken}`
            }
          }
        )
        .then(response => {
          const user = response.data
          return user
        })
    },
    setProfile({ commit }, profile) {
      // missing action here to upload the user image somewhere
      commit('setProfile', profile)
    },
    // TODO: Safely remove, logout through auth store
    logoutUser() {
      return firebase.auth().signOut()
    }
  }
}
